import React from "react";
import ReactDOM from "react-dom";
import axe from "@axe-core/react";
import axeCore from "axe-core";

interface ReactSpec extends axeCore.Spec {
  runOnly?: string[];
  disableDeduplicate?: boolean;
}

const initAxeTesting = () => {
  const config: ReactSpec = {
    rules: [],
    // disableDeduplicate: true,
  };

  const context: axeCore.ElementContext = {
    exclude: [],
  };

  axe(React, ReactDOM, 1000, config, context);
};

export { initAxeTesting };
